import { createFileRoute } from "@tanstack/react-router";
import { CustomerContainer } from "../../app/views/customerContainer";

export const Route = createFileRoute("/customer/customers")({
  component: CustomerContainer,
});
